import $ from 'jquery'
$(function() {
  $('form.dirty-check').areYouSure({'message':'Er du sikker, alt er ikke gemt!'} );
})